<template>
	<div class="flex flex-col items-center">
		<div>
			<img
				v-if="brand === 'MHL'"
				class="w-60 my-10"
				src="@/assets/logos/mabey-hire-logo.svg"
				alt="Mabey Hire"
				data-testid="logo" />

			<img
				v-else-if="brand === 'MHI'"
				class="w-60 my-5"
				src="@/assets/logos/mh-international-logo.svg"
				alt="MH International"
				data-testid="logo" />

			<div v-else class="my-10 w-60 h-20 bg-gray-300 animate-pulse rounded-md"></div>
		</div>

		<app-panel>
			<item-details :item="item"> </item-details>
		</app-panel>
	</div>
</template>

<script lang="ts" setup>
	import ItemDetails from '@/components/partials/product-data/ItemDetails.vue'
	import { onMounted, ref } from 'vue'
	import { useRoute } from 'vue-router'
	import { IpService } from '@/services/api/ip'
	import type { Item } from '@/data/schema/item'

	const route = useRoute()
	const item = ref<Item>(route.meta.item as Item)

	const ipService = new IpService()

	const brand = ref()

	onMounted(async () => {
		const country = await ipService.getCountry()
		brand.value = country === 'GB' ? 'MHL' : 'MHI'
	})
</script>
